import React from 'react';
import { Icon } from 'react-materialize';
import { BLOG_URL } from '../../config/constants';
import './styles.scss';

/**
 * Blog Link Component
 *
 * Links to external blog at https://blog.mindfuljr.com/
 * Provides information about blog content and encourages exploration.
 */

export const BlogLink = () => {
  return (
      <section id="resources" className="section">
      <div className="container">
        <h2>Resources & Insights</h2>
        <div className="blog-link-content">
            <p>
              My blog offers <strong>practical mindfulness exercises</strong>, <strong>dharma‑inspired perspectives</strong>, and <strong>contemplative writing</strong> — all shaped by lived practice and written to support <strong>steadiness</strong>, <strong>insight</strong>, and a more grounded relationship with your own mind. You'll find <strong>tools you can use right away</strong>, reflections on the <strong>foundations of meditation</strong>, and <strong>poetry</strong> that explores the inner landscape with clarity and warmth.
            </p>


          <div className="blog-link-button-container">
            <a
              href={BLOG_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="blog-link-button"
            >
              <Icon className="blog-icon">chat</Icon>
              Visit Blog
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
